import React from 'react';

import {
  IAffiliateHeroFields,
  IFeaturedBlogPostFields,
  IFullwidthHero20Fields,
  IHomepageHeroFields,
  IOverlayHeroFields,
  IPageFields,
  IPerformanceHeroFields,
  ISideBySideHeroFields,
  IStackedHeroFields,
  ITextOnlyHeroFields
} from '../../../types/contentful';

import { AffiliateHero } from '../AffiliateHero/1.0';
import { AffiliateHero2, AffiliateHero2Props } from '../AffiliateHero/2.0';
import { FeaturedBlogPost } from '../BlogComponents/FeaturedPost';
import { FullwidthHero } from '../FullwidthHero';
import { PerformanceHero } from '../PerformanceHero';
import { HomepageHero } from '../HomepageHero';
import { OverlayHero } from '../OverlayHero';
import { SideBySideHero } from '../SideBySideHero';
import { StackedHero } from '../StackedHero';
import { TextOnlyHero } from '../TextOnlyHero';
import { VariationContainer } from '../VariationContainer';

export function HeroBlock({ heroBlock }: IPageFields) {
  const { sys, fields } = heroBlock ?? {};

  switch (sys?.contentType?.sys?.id) {
    case 'affiliateHero':
      return <AffiliateHero {...(fields as IAffiliateHeroFields)} />;

    case 'affiliateHero20':
      return <AffiliateHero2 {...(fields as AffiliateHero2Props)} />;

    case 'featuredBlogPost':
      return <FeaturedBlogPost {...(fields as IFeaturedBlogPostFields)} />;

    case 'fullwidthHero20':
      return <FullwidthHero {...(fields as IFullwidthHero20Fields)} />;

    case 'homepageHero':
      return <HomepageHero {...(fields as IHomepageHeroFields)} />;

    case 'overlayHero':
      return <OverlayHero {...(fields as IOverlayHeroFields)} />;

    case 'performanceHero':
      return <PerformanceHero {...(fields as IPerformanceHeroFields)} />;

    case 'sideBySideHero':
      return <SideBySideHero {...(fields as ISideBySideHeroFields)} />;

    case 'stackedHero':
      return <StackedHero {...(fields as IStackedHeroFields)} />;

    case 'textOnlyHero':
      return <TextOnlyHero {...(fields as ITextOnlyHeroFields)} />;

    case 'variationContainer':
      return <VariationContainer {...fields} sysId={sys?.id} />;

    default:
      return null;
  }
}
